import { memo } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryResultDetailsQuestions.module.scss";
import { ISociometryPupilResultAnswer } from "../../model/types/sociometryPupilResult";

interface SociometryResultDetailsQuestionsProps {
    className?: string;
    questionNumber: number;
    answer: ISociometryPupilResultAnswer;
}

export const SociometryResultDetailsQuestions = memo((props: SociometryResultDetailsQuestionsProps) => {
    const { className, questionNumber, answer } = props;

    return (
        <div className={classNames(cls.sociometryResultDetailsQuestions, {}, [className])}>
            <div className={cls.numberHolder}>
                <p className={cls.numberText}>{`Вопрос ${questionNumber}`}</p>
            </div>
            <p className={cls.questionText}>{answer.question}</p>
            <p className={cls.answerText}>{answer.chosen.join(", ")}</p>
        </div>
    );
});

SociometryResultDetailsQuestions.displayName = "SociometryResultDetailsQuestions";
